module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "aside",
    class: {
      aside_hide: _vm.isHide
    }
  }, [_c('router-link', {
    staticClass: "aside__logo",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("resursable")]), _vm._v(" "), _c('nav', {
    staticClass: "nav",
    attrs: {
      "role": "nav"
    }
  }, [_c('ul', _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('router-link', {
      staticClass: "nav__item",
      attrs: {
        "to": '/' + item
      }
    }, [_vm._v(_vm._s(item))])], 1)
  }), 0)]), _vm._v(" "), _c('a', {
    staticClass: "aside__toggleBtn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleNav.apply(null, arguments)
      }
    }
  }, [_vm._v("\n    ↔\n  ")]), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_vm._m(0), _vm._v(" "), _c('small', {
    staticClass: "footer__copyright"
  }, [_vm._v("\n      Copyright © " + _vm._s(_vm.year) + "\n    ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('address', [_c('a', {
    staticClass: "footer__link",
    attrs: {
      "href": "https://max-im.github.io/",
      "target": "_blank"
    }
  }, [_vm._v("\n        Max Pozhidayev\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60b8a619","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navPanel.vue
// module id = 73
// module chunks = 0